/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Event
 */
export interface Event {
  /**
   *
   * @type {string}
   * @memberof Event
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof Event
   */
  readonly gmwWellCode?: string;
  /**
   *
   * @type {string}
   * @memberof Event
   */
  readonly gmwBroId?: string;
  /**
   *
   * @type {string}
   * @memberof Event
   */
  eventName: string;
  /**
   *
   * @type {Date}
   * @memberof Event
   */
  eventDate: Date;
  /**
   *
   * @type {object}
   * @memberof Event
   */
  metadata?: object;
  /**
   *
   * @type {object}
   * @memberof Event
   */
  sourcedocumentData?: object;
  /**
   *
   * @type {Date}
   * @memberof Event
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof Event
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof Event
   */
  gmw: string;
  /**
   *
   * @type {string}
   * @memberof Event
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the Event interface.
 */
export function instanceOfEvent(value: object): value is Event {
  if (
    (!("eventName" in (value as Record<string, any>)) &&
      !("event_name" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["eventName"] === undefined &&
      (value as Record<string, any>)["event_name"] === undefined)
  )
    return false;
  if (
    (!("eventDate" in (value as Record<string, any>)) &&
      !("event_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["eventDate"] === undefined &&
      (value as Record<string, any>)["event_date"] === undefined)
  )
    return false;
  if (!("gmw" in value) || value["gmw"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function EventFromJSON(json: any): Event {
  return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    gmwWellCode: json["gmw_well_code"] == null ? undefined : json["gmw_well_code"],
    gmwBroId: json["gmw_bro_id"] == null ? undefined : json["gmw_bro_id"],
    eventName: json["event_name"],
    eventDate: new Date(json["event_date"]),
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    sourcedocumentData:
      json["sourcedocument_data"] == null ? undefined : json["sourcedocument_data"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    gmw: json["gmw"],
    dataOwner: json["data_owner"],
  };
}

export function EventToJSON(json: any): Event {
  return EventToJSONTyped(json, false);
}

export function EventToJSONTyped(
  value?: Omit<Event, "uuid" | "gmw_well_code" | "gmw_bro_id" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    event_name: value["eventName"],
    event_date: value["eventDate"].toISOString().substring(0, 10),
    metadata: value["metadata"],
    sourcedocument_data: value["sourcedocumentData"],
    gmw: value["gmw"],
    data_owner: value["dataOwner"],
  };
}
